import * as angular from "angular";
import {IController} from "angular";

export class taskRelationCardCtrl implements IController {

  relation: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskRelationCard', {
    bindings: {
      relation: '<'
    },
    template: require('./task-relation-card.html').default,
    controller: taskRelationCardCtrl
  });
